/**
* 系统管理
*/
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">系统管理</el-breadcrumb-item>
      <el-breadcrumb-item>部门管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" class="user-search">

      <!-- <el-form-item label="搜索：">
        <el-input size="small" v-model="editForm.departmentName" placeholder="输入部门名称"></el-input>
      </el-form-item> -->

      <el-form-item>
        <!-- <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button> -->
        <!-- <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加</el-button> -->
        <prems-button perms="sys:dep:add" label="添加" icon="el-icon-circle-plus-outline" size="small" type="primary" @click="handleEdit" />
      </el-form-item>
    </el-form>



    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border row-key="id" :header-cell-style="this.$store.state.headerCss"
      element-loading-text="拼命加载中"  :max-height="tableHeight" style="width: 100%;" :tree-props="{children: 'deps',hasChildren: 'hasChildren'}">

      <el-table-column align="center" type="index" width="60" label="序号">
      </el-table-column>
      <el-table-column prop="departmentName" label="公司名称" width="200">
      </el-table-column>
      <el-table-column prop="departmentAdmin" label="管理员" width="200">
      </el-table-column>
     <el-table-column label="公司印章" width="200">
        <template slot-scope="scope">
         <img style="width: 60px; height: 60px;" v-if="scope.row.sealImg" :src="scope.row.sealImg[0].url" />
        </template>
      </el-table-column>
     <!-- <el-table-column prop="parentName" label="上级单位" width="200">
      </el-table-column> -->
      <el-table-column prop="createDate" label="创建时间" width="200">
        <template slot-scope="scope">
          <div>{{scope.row.createDate|timestampToTime}}</div>
        </template>
      </el-table-column>
      <el-table-column prop="updateDate" label="修改时间" width="240">
        <template slot-scope="scope">
          <div>{{scope.row.updateDate|timestampToTime}}</div>
        </template>
      </el-table-column>
      <!-- <el-table-column sortable prop="editUser" label="修改人" width="300">
      </el-table-column> -->
      <el-table-column align="center" label="操作" min-width="300">
        <template slot-scope="scope">

          <prems-button perms="sys:dep:update" label="编辑" size="mini" @click="handleEdit(scope.$index, scope.row,'edit')" />
          <prems-button perms="sys:dep:delete" label="删除" size="mini" type="danger" @click="deleteUser(scope.$index, scope.row)" />
          <prems-button perms="sys:dep:set" label="设置管理员" size="mini" type="success" @click="setAdmin(scope.$index, scope.row)" />
          <prems-button perms="sys:dep:set" label="配置短信模板" size="mini" type="primary" @click="setMsg(scope.row)" />
          <prems-button perms="sys:dep:update" label="上传印章" size="mini" type="primary" @click="handleyz(scope.row)" />
        </template>
      </el-table-column>
    </el-table>

    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="30%" @click='closeDialog("edit")' :close-on-click-modal="false">
      <el-form label-width="120px" :model="editForm" ref="editForm" :rules="rules">

        <el-form-item label="部门名称" prop="departmentName">
          <el-input  size="small" v-model="editForm.departmentName" auto-complete="off" placeholder="请输部门名称"></el-input>
        </el-form-item>
       <el-form-item label="差值">
          <el-input size="small"  v-model="editForm.diff" auto-complete="off" placeholder="请输入差值(用于线损计算)"></el-input>
        </el-form-item>
        <el-form-item label="部门类型" prop="accountType">

          <el-select size="small"  v-model="editForm.accountType" clearable placeholder="请选择">
            <el-option label="不入库" value='1'></el-option>
            <el-option label="预付费" value='2'></el-option>
            <el-option label="只抄表" value='3'></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="所属" v-if="title == '添加'">
          <el-cascader size="small"  v-model="deptDatas" ref="depsCascader" :options="deptFristData" :props="{ expandTrigger: 'click',children:'deps',label:'departmentName',checkStrictly: true,value:'id'}"
            @change="handleChange">
          </el-cascader>
        </el-form-item>
        <el-form-item label="推送预警消息：">
          <el-radio-group v-model="editForm.isAlarm">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
          </el-radio-group>
         </el-form-item>

      </el-form>


      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='closeDialog("edit")'>取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">保存</el-button>
      </div>
    </el-dialog>
    <!-- 设置部门管理员 -->
    <el-dialog :title="disTitle" :visible.sync="deptShow" width="30%" @click='closeDialog("perm")' :close-on-click-modal="false">
      <el-form label-width="120px" :model="editForm" ref="editForm" :rules="rules">

        <el-form-item label="设置管理员">
          <el-select v-model="getAdmin" placeholder="请选择">
            <el-option v-for="item in userData" :key="item.uid" :label="item.username" :value="item.uid">
            </el-option>
          </el-select>
        </el-form-item>

      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='closeDialog("perm")'>取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="setAdminSave()">保存</el-button>
      </div>
    </el-dialog>

    <!-- 设置短信模板 -->
    <el-dialog title="设置短信模板" :visible.sync="msgShow" width="50%" @click='closeDialog("msg")' :close-on-click-modal="false">
      <el-form :model="msgForm" ref="msgForm"   label-width="126px" :inline="true">
        <el-row :gutter="12" v-for="(item,idx) in dynamicForm" :key="idx">
          <el-col :span="4">
            <el-form-item >
              <el-select size="small" placeholder="请选择类型" v-model="dynamicForm[idx].msgType">
                <el-option
                  v-for="item in msgTypes"
                  :key="item.id"
                  :label="item.type"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item >
              <el-select size="small" placeholder="请选择模板" v-model="dynamicForm[idx].templateId">
                <el-option
                  v-for="item in templateList"
                  :key="item.id"
                  :label="item.templateName"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item >
              <el-select size="small" placeholder="请选择签名" v-model="dynamicForm[idx].signId">
                <el-option
                  v-for="item in signList"
                  :key="item.id"
                  :label="item.signName"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4" style="position: relative;">

            <el-form-item >
              <el-input size="small" v-model="dynamicForm[idx].threshold" placeholder="请输入阈值"></el-input>
            </el-form-item>
            <el-tooltip placement="top" effect="light">
              <div slot="content">
                <p>阈值格式：</p>
                <p>1:[0,20)</p>
                <p>2:'['左边中括号为开始的值, ‘)’右边小括号为结束的值 </p>
              </div>
              <i class="el-icon-warning iconPositon" ></i>
            </el-tooltip>
          </el-col>
          <el-col :span="4" >
            <el-form-item >
              <el-input size="small" v-model="dynamicForm[idx].days" placeholder="多少天提醒一次"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item>
              <el-button size="small" type="primary" icon="el-icon-plus" @click="addForm"></el-button>
              <el-button size="small" type="danger" icon="el-icon-delete" @click="deleteForm(item,idx)"></el-button>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="是否开启短信推送">
           <el-switch v-model="isTempSendMsg" @change="switchMsg"></el-switch><i class="el-icon-loading" v-if="loadMsg"></i>
        </el-form-item>
      </el-form>


      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='closeDialog("msg")'>取消</el-button>
        <el-button size="small" type="primary" :loading="loadSave" class="title" @click="saveConfig">保存</el-button>
      </div>
    </el-dialog>

    <el-dialog :title="title" :visible.sync="yzVisible" width="30%" @click='closeDialog("edit")' :close-on-click-modal="false">
      <el-form label-width="120px" :model="editForm" ref="editForm" :rules="rules">


        <el-form-item label="公司印章" prop="yinzhang">
          <el-upload class="upload-img" ref="uploadimg" action="#" :file-list="fileList"
            :before-upload="beforeZhiZhaoupload" >

            <el-button size="small" type="primary" :loading="loadZhiZhao">点击上传</el-button>
          </el-upload>
        </el-form-item>

      </el-form>


      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='yzVisible = false'>取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="saveYz">保存</el-button>
      </div>
    </el-dialog>


  </div>
</template>

<script>
  import {
    deptList,
    departmentAdd,
    getUserByDeptId,
    setAdminMG,
    departmentUpdate,
    deptDelete,
    deptListFirst,
    getAllMsgSign,
    getAllMsgTemplate,
    getMsgConfig,
    saveMsgConfig,
    openOrCloseSendMsg,
    getMsgType,
    uploadSeal,
    uploadFile,

  } from '../../api/userMG'

  import Pagination from '../../components/Pagination'
  import PremsButton from "@/views/permission/PreButtom";
  export default {
    data() {
      return {
        tableHeight:0,
        loadSave:false,
        msgShow: false,
        loadMsg:false,
        msgForm: {},
        yzVisible:false,
        loading: false, //是显示加载
        editFormVisible: false, //控制编辑页面显示与隐藏
        deptShow: false, //
        isSendMsg:false,
        isTempSendMsg:false,
        title: '添加',
        disTitle: '',

        editForm: {
          departmentName: '',
          parentId: 0,
          parentName: '',
          accountType:'2',
          diff:"",
          isAlarm:0,//2023.11.22是否推送预警消息 默认不开启
        },
        user: {},
        userListForm: false,
        departmentId:"",
        rules: {
          departmentName: [{
            required: true,
            message: '请输入部门名称',
            trigger: 'blur'
          }],
        },
        currRoleId: 0,
        delIds: '',
        deptDatas: [],
        deptFristData: [],
        listData: [],
        userData: [],
        getAdmin: '',
        menuTreeData: [],
        RoleRightProps: {
          label: "name",
          children: "menus"
        },
        // 选中
        checkmenu: [],
        //参数role
        deptId: 0,
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        },
        signList:[],
        templateList:[],
        msgList:[],
        fileList:[],
        yId:"",
        dynamicForm:[
          {
           threshold:'',
           days:'',
           msgType:'',
           "signId": '',
           "templateId": '',
           "departmentId":this.departmentId
          }
        ],
        loadZhiZhao:false,
        msgTypes:[
          { label:'欠费提醒',value:1 },
          { label:'拉闸提醒',value:2 },
        ],


      }
    },
    // 注册组件
    components: {
      Pagination,
      PremsButton
    },
    /**
     * 数据发生改变
     */

    watch: {},

    /**
     * 创建完毕
     */

    created() {
      this.getdata()
      this.user = JSON.parse(sessionStorage.getItem('userdata'))

      this.getSign();
      this.getTemplate();
      this.getMsgType()
      //this.getMsg();

    },
    mounted() {
      this.$nextTick(() => {
      	this.tableHeight = window.innerHeight - 175-60
      })
    },

    /**
     * 里面的方法只有被调用才会执行
     */

    methods: {
      saveYz(){
        let param = {
          depId:this.yId,
          imgName:JSON.stringify(this.fileList)
        }
        uploadSeal(param).then(res => {
          this.yzVisible = false
          if(res.status == 1){
            this.$message.success('操作成功')
            this.getdata()
          }else{
            this.$message.error(res.msg)
          }
        })

      },

      handleyz(row){
        this.yzVisible = true
        this.yId  = row.id
        console.log(row.sealImg)
        this.fileList = row.sealImg || []
       },

      beforeZhiZhaoupload(file) {
        this.loadZhiZhao = true
        let modiFormData = new FormData()
        modiFormData.append('modiFile', file)
        modiFormData.append('pathName', 'seal-path')

        uploadFile(modiFormData).then(res => {
           this.loadZhiZhao = false
          if (res.status == 1) {
            let tempArr = []
            tempArr.push({
              name: res.fileName,
              url: res.url
            })
            this.fileList = tempArr

          }
        })
        return false
      },

      getMsgType(){
        getMsgType().then(res => {
          if(res.status == 1){
            this.msgTypes = res.data
          }else{
            this.$message.error('res.msg')
          }
        })
      },

      // 获取角色列表
      getdata() {

        /***
         * 调用接口，注释上面模拟数据 取消下面注释
         */
        this.loading = true
        deptList().then(res => {
            this.loading = false
            if (res.status == 1) {
              this.listData = res.data

            } else {
              this.$message.error(res.msg)
            }

          })
          .catch(err => {
            this.loading = false
            this.$message.error('获取数据失败，请稍后再试！')
          })
      },
      //获取一级部门
      getFristDept() {
        deptListFirst().then(res => {
            this.loading = false
            if (res.status == 1) {
              this.deptFristData = res.data

            } else {
              this.$message.error(res.msg)
            }

          })
          .catch(err => {
            this.loading = false
            this.$message.error('获取数据失败，请稍后再试！')
          })
      },
      handleChange(e) {

        let id = e[e.length - 1]
        let names = this.$refs.depsCascader.getCheckedNodes()[0].pathLabels
        let name = names[names.length - 1]

        this.editForm.parentName = name
        this.editForm.parentId = id


      },


      //获取所有的签名
      getSign(){
        getAllMsgSign().then(res =>{
          if(res.status == 1){
            this.signList = res.data
          }
        })
      },

      //获取所有的签名
      getSign(){
        getAllMsgSign().then(res =>{
          if(res.status == 1){
            this.signList = res.data
          }
        })
      },
      // 获取所有的模板
      getTemplate(){
        getAllMsgTemplate().then(res => {
          if(res.status == 1){
            this.templateList = res.data
          }
        })
      },

      // 获取短信配置
      getMsg(){
        getMsgConfig().then(res => {
          if(res.status == 1){
            this.msgList = res.data
          }
        })
      },


      //显示编辑界面
      handleEdit: function(index, row,edit) {
        this.editFormVisible = true
        // 2023.11.23 第一次点击编辑 this.$refs.editForm为undefined，报错，导致后面运行停止修改
        if(this.$refs.editForm!=undefined &&this.$refs.editForm!='undefined' ){
          this.$refs.editForm.clearValidate()
        }
        if (edit == 'edit') {
          this.title = '修改'
          this.deptId = row.id
          this.editForm.departmentName = row.departmentName
          this.editForm.parentId = row.parentId
          this.editForm.parentName = row.parentName
          this.editForm.accountType = row.accountType+''
          this.editForm.diff = row.diff || ''
          this.deptDatas = [row.parentId]
          if(row.isAlarm==false){
            this.editForm.isAlarm = 0
          }else{
            this.editForm.isAlarm = 1
          }


        } else {

          this.title = '添加'
          this.editForm.departmentName = ""
          this.editForm.parentId = 0
          this.editForm.parentName = ""
          this.editForm.diff = ""
          this.deptDatas = []
          this.deptFristData = []
          this.editForm.isAlarm = 0
          this.getFristDept();

        }
      },
      // 编辑、增加保存方法
      submitForm(editData) {
        console.log(this.editForm)
        this.$refs[editData].validate(valid => {
          if (valid) {
            if (this.title == '添加') {
              if (this.user.name != 'admin') {
                if (!this.editForm.parentId) {
                  this.$message.error('请选择所属部门！')
                }
              }
              this.deptAdd()
            } else {
              this.deptUpdate()
            }

          } else {
            return false
          }
        })
      },

      // 删除角色
      deleteUser(index, row) {
        this.$confirm('确定要删除吗?', '信息', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {



            let parm = {
              id: row.id,
              departmentName: row.departmentName,
              parentId: row.parentId
            }
            deptDelete(parm)
              .then(res => {

                if (res.status == 1) {
                  this.$message({
                    type: 'success',
                    message: '部门已删除！'
                  })
                  this.getdata()
                } else {
                  this.$message({
                    type: 'error',
                    message: res.msg
                  })
                }
              })
              .catch(err => {
                this.loading = false
                this.$message.error('部门删除失败，请稍后再试！')
              })
          })
          .catch((err) => {
            console.log(err)
            this.$message({
              type: 'info',
              message: '已取消删除'
            })
          })
      },



      // 设置管理员
      setAdmin: function(index, row) {

        this.deptShow = true
        this.saveroleId = row.id
        this.disTitle = '给部门 ' + row.departmentName + ' 设置管理员'


        getUserByDeptId({
            depId: this.saveroleId
          })
          .then(res => {
            if (res.status == 1) {
              this.userData = res.data
            } else {
              this.$message({
                type: 'error',
                message: res.data.msg
              })
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('服务器错误！，请稍后再试！')
          })
      },

      //打开短信模板窗口
      setMsg(row) {
        this.msgShow = true
        this.departmentId = row.id



        this.isSendMsg = row.isSendMsg
        //给临时 的switch的加个状态,因为每次点击switch组件的时候会首先触发v-model
        this.isTempSendMsg = row.isSendMsg
        getMsgConfig({departmentId:row.id}).then(res => {
          if(res.status == 1 ){
            if(res.data.length){
              this.dynamicForm = res.data
            }else{
              this.dynamicForm = [
                {
                 threshold:'',
                 days:'',
                 msgType:'',
                 "signId": '',
                 "templateId": '',
                 "departmentId":this.departmentId
                }
              ]
            }

          }
        })

      },

      addForm(){
        this.dynamicForm.push({
            threshold:'',
            days:'',
            msgType:'',
            "signId": '',
            "templateId": '',
            "departmentId":this.departmentId
        })

      },
      deleteForm(item,idx){
        if(this.dynamicForm.length == 1){
          this.dynamicForm = [{
            threshold:'',
            days:'',
            msgType:'',
            "signId": '',
            "templateId": '',
            "departmentId":this.departmentId
          }]
        }else{
           this.dynamicForm.splice(idx, 1)
        }

      },

      saveConfig(){

        let param = {
          departmentId:this.departmentId,
          msgConfig:JSON.stringify(this.dynamicForm)
        }
        this.loadSave = true
        saveMsgConfig(param).then(res => {
          this.msgShow = false
           this.loadSave = false
          if(res.status == 1){

            this.$message.success('操作成功！')
          }else{
             this.$message.error(res.msg)
          }
        })

      },

      //开户或关闭短信推送
      switchMsg(e){
        //先让switch 保持原有的状态
        this.isTempSendMsg = this.isSendMsg
        let msg = this.isSendMsg ? '关闭':'开启'
        this.$confirm('是否'+msg+'短信推送?', '信息', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(()=>{
            this.loadMsg = true
            let param = {
              id:this.departmentId,
              isSendMsg:!this.isSendMsg
            }
            openOrCloseSendMsg(param).then( res => {
                this.loadMsg = false
                if(res.status == 1 ){
                   this.$message.success('操作成功！')
                   this.isTempSendMsg = !this.isTempSendMsg
                   this.isSendMsg = !this.isSendMsg
                   this.getdata()
                }
            })
          })
          .catch()

      },



      // 设置管理员保存
      setAdminSave() {
        let parm = {
          userInfoId: this.getAdmin,
          depId: this.saveroleId
        }
        setAdminMG(parm).then(res => {
            this.deptShow = false
            this.loading = false
            if (res.status == 1) {
              this.$message.success('部门管理员设置成功！')
              this.getdata()
            } else {
              this.$message.error(res.msg)
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('服务器错误！，请稍后再试！')
          })
      },




      //新增部门
      deptAdd() {
        departmentAdd(this.editForm)
          .then(res => {
            if (res.status == 1) {
              this.$message({
                type: 'success',
                message: '新增部门成功'
              })
              this.editFormVisible = false
              this.getdata()

            } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('服务器错误，请稍后再试！')
          })
      },

      deptUpdate() {

        departmentUpdate({ ...this.editForm,
          id: this.deptId
        }).then(res => {
          this.editFormVisible = false
          this.loading = false
          if (res.status == 1) {
            this.$message.success('操作成功！')
            this.getdata()
          } else {
            this.$message.error(res.msg)
          }
        })
      },


      // 关闭编辑、增加弹出框
      closeDialog(dialog) {
        if (dialog == 'edit') {
          this.editFormVisible = false
        } else if (dialog == 'perm') {
          this.deptShow = false
        } else if (dialog == 'msg') {
          this.msgShow = false
        }
      }
    }
  }
</script>

<style scoped>
  .userRole {
    width: 100%;
  }
  .iconPositon{
    position: absolute;
    right: 0;
    top: 0;
  }
</style>



// WEBPACK FOOTER //
// src/views/system/UserGroup.vue